/**
 * Returns LOP API base URL
 * @returns {string}
 */
export function getLopUrl() {
  // @ts-ignore
  const env = import.meta.env
  const VITE_LOP_URL = env.VITE_LOP_URL

  const prod = 'https://module-manager.trbotrkr.com/api'

  if (VITE_LOP_URL === 'undefined') {
    return prod
  }

  return VITE_LOP_URL || prod
}
